import type { ReactNode } from 'react';

import { CHALLENGE_WIDGET, CHALLENGE_WIDGET_TEXT } from '../../../constants';
import { ChallengeProgressBar } from '../ChallengeProgressBar/ChallengeProgressBar';

import styles from './ChallengeSmallWidget.module.scss';

interface ChallengeSmallWidgetProps {
  progressPercentage: number;
  target: number;
  current: number;
  timerIncluded?: boolean;
  timer?: ReactNode;
}

export function ChallengeSmallWidget(props: ChallengeSmallWidgetProps) {
  const { timerIncluded, progressPercentage, target, current, timer } = props;
  return (
    <div className={styles.container}>
      <img alt="" className={timerIncluded ? styles.imgWithTimer : styles.imgWithoutTimer} src={CHALLENGE_WIDGET} />
      <img
        alt=""
        className={timerIncluded ? styles.imgTextWithTimer : styles.imgTextWithoutTimer}
        src={CHALLENGE_WIDGET_TEXT}
      />
      {timerIncluded ? (
        <div className={styles.progressBarWrapperWithTimer}>
          <ChallengeProgressBar current={current} progressPercentage={progressPercentage} target={target} />
          {timer}
        </div>
      ) : (
        <div className={styles.progressBarWrapperWithoutTimer}>
          <ChallengeProgressBar current={current} progressPercentage={progressPercentage} target={target} />
        </div>
      )}
    </div>
  );
}
